__turbopack_context__.v({
  "content": "AssignmentWidget-module-scss-module__cDTFMa__content",
  "description": "AssignmentWidget-module-scss-module__cDTFMa__description",
  "fade-in": "AssignmentWidget-module-scss-module__cDTFMa__fade-in",
  "gradient": "AssignmentWidget-module-scss-module__cDTFMa__gradient",
  "no-transform": "AssignmentWidget-module-scss-module__cDTFMa__no-transform",
  "rotate": "AssignmentWidget-module-scss-module__cDTFMa__rotate",
  "widget": "AssignmentWidget-module-scss-module__cDTFMa__widget",
  "wrapper": "AssignmentWidget-module-scss-module__cDTFMa__wrapper",
});
